import type { Themeable } from '../../themeable'
import { type DefaultContentRender, normalizeDefaultContent } from '../DefaultContent'
import type { ModalSetup } from '../ModalSetup'
import { Card } from './Card'
import type { Options } from './Options'

export const showCardCreate =
	(themeableOptions: Themeable<Options>): ModalSetup<DefaultContentRender> =>
	(content, onClose) => {
		const { isFocusTrapEnabled, isDismissable, onClosed, ...rest } = normalizeDefaultContent(content({ onClose }))

		return {
			render: {
				content: (key, props) => <Card key={key} themeableOptions={themeableOptions} {...rest} {...props} />,
				duration: 0.2,
			},
			isFocusTrapEnabled,
			isDismissable,
			onClosed,
		}
	}
